import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "step-1-create-a-customer"
    }}>{`Step 1. Create a customer`}</h1>
    <p>{`This step creates a customer account and generates an authentication token for that customer. You can skip this step if you want to perform this tutorial as a guest user.`}</p>
    <h2 {...{
      "id": "create-a-customer"
    }}>{`Create a customer`}</h2>
    <p>{`Use the `}<inlineCode parentName="p">{`createCustomer`}</inlineCode>{` mutation to register the new customer account in the store.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  createCustomer(
    input: {
      firstname: "John"
      lastname: "Doe"
      email: "john.doe@example.com"
      password: "b1b2b3l@w+"
      is_subscribed: true
    }
  ) {
    customer {
      firstname
      lastname
      email
      is_subscribed
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "createCustomer": {
      "customer": {
        "firstname": "John",
        "lastname": "Doe",
        "email": "john.doe@example.com",
        "is_subscribed": true
      }
    }
  }
}
`}</code></pre>
    <p>{`The `}<a parentName="p" {...{
        "href": "../../schema/customer/mutations/create.md"
      }}><inlineCode parentName="a">{`createCustomer`}</inlineCode></a>{` mutation describes additional parameters.`}</p>
    <h2 {...{
      "id": "generate-an-authentication-token-for-the-customer"
    }}>{`Generate an authentication token for the customer`}</h2>
    <p>{`To place an order as a customer, you must obtain an authorization token by calling the `}<inlineCode parentName="p">{`generateCustomerToken`}</inlineCode>{` mutation. You must include the customer's email and password as input.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  generateCustomerToken(email: "john.doe@example.com", password: "b1b2b3l@w+") {
    token
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "generateCustomerToken": {
      "token": "zuo7zor5jfldft2nmu2gtylnm8ui7e8t"
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "specify-an-authorization-header"
    }}>{`Specify an Authorization header`}</h2>
    <p>{`To send requests on behalf of the customer, you must supply the generated token as a header in your GraphQL browser.
The name of the header is `}<inlineCode parentName="p">{`Authorization`}</inlineCode>{` and the value is `}<inlineCode parentName="p">{`Bearer <token>`}</inlineCode>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "../../usage/authorization-tokens.md"
      }}>{`Authorization tokens`}</a>{` describes the mutation further.`}</p>
    <h2 {...{
      "id": "verify-this-step"
    }}>{`Verify this step`}</h2>
    <p>{`Sign in as a customer to the website using the email `}<inlineCode parentName="p">{`john.doe@example.com`}</inlineCode>{` and password `}<inlineCode parentName="p">{`b1b2b3l@w+`}</inlineCode>{`. You should be successfully logged in.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      